export const aciLinkedin = {
    iconName: 'linkedin',
    iconData: [
        24,
        24,
        `M8 9.6a.8.8 0 00-1.6 0H8zm-1.6 8a.8.8 0 001.6 0H6.4zm3.2 0a.8.8 0 001.6 0H9.6zm6.4 0a.8.8 0 001.6 0H16zm-4.8-8a.8.8 0 00-1.6 0h1.6zm-4-3.2a.8.8 0 000 1.6V6.4zM7.304 8a.8.8 0 000-1.6V8zM2.4 1.6h19.2V0H2.4v1.6zm20 .8v19.2H24V2.4h-1.6zm-.8 20H2.4V24h19.2v-1.6zm-20-.8V2.4H0v19.2h1.6zm.8.8a.8.8 0 01-.8-.8H0A2.4 2.4 0 002.4 24v-1.6zm20-.8a.8.8 0 01-.8.8V24a2.4 2.4 0 002.4-2.4h-1.6zm-.8-20a.8.8 0 01.8.8H24A2.4 2.4 0 0021.6 0v1.6zM2.4 0A2.4 2.4 0 000 2.4h1.6a.8.8 0 01.8-.8V0zm4 9.6v8H8v-8H6.4zm4.8 8v-4H9.6v4h1.6zm4.8-4v4h1.6v-4H16zm1.6 0a4 4 0 00-4-4v1.6a2.4 2.4 0 012.4 2.4h1.6zm-6.4 0a2.4 2.4 0 012.4-2.4V9.6a4 4 0 00-4 4h1.6zm-1.6-4v8h1.6v-8H9.6zM7.2 8h.104V6.4H7.2V8z`,
    ],
};
